import { render, staticRenderFns } from "./AppTag.vue?vue&type=template&id=e6cb13a2&"
import script from "./AppTag.vue?vue&type=script&lang=js&"
export * from "./AppTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports